/**
 * Product Context - Global product list storage
 * Accessible from any file in the src directory
 */

let cartProductsList: any[] = [];

export const ProductContext = {
    /**
     * Get the current cart products list
     */
    getCartProductsList(): any[] {
        return cartProductsList;
    },

    /**
     * Set the cart products list
     */
    setCartProductsList(products: any[]): void {
        cartProductsList = products;
    },

    /**
     * Update/add a single product to the cart products list
     */
    updateProduct(product: any): void {
        const existingIndex = cartProductsList.findIndex(
            item => Number(item.pid || item.id) === Number(product.pid || product.id)
        );
        if (existingIndex !== -1) {
            cartProductsList[existingIndex] = product;
        } else {
            cartProductsList.push(product);
        }
    },

    /**
     * Clear all product lists
     */
    clear(): void {
        cartProductsList = [];
    }
};

